<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择用户"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="system/user">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="姓名">
            <el-input v-model.trim="filter.employeeName" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="用户类型">
            <el-select v-model="filter.userType" clearable>
              <el-option label="内部用户" :value="1"/>
              <el-option label="外部用户" :value="2"/>
              <el-option label="高级用户" :value="3"/>
            </el-select>
          </vm-search>
          <vm-search label="用户名">
            <el-input v-model.trim="filter.userName" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="手机">
            <el-input v-model.trim="filter.mobile" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="角色">
            <el-input v-model.trim="filter.roleName" placeholder="请输入" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="userName" width="180" label="用户名"/>
      <el-table-column prop="employeeName" label="姓名"/>
      <el-table-column prop="userTypeName" align="center" width="100" label="用户类型"/>
      <el-table-column prop="mobile" align="center" width="120" label="手机"/>
      <el-table-column prop="departmentName" width="180" label="所属部门"/>
      <el-table-column prop="roleName" label="所属角色"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";


  export default {
    name:"UserSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          userName: "",
          userType: "",
          employeeName: "",
          mobile: "",
          roleName: "",
          accountSetName: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
